import Experts from '~/pages/onboarding/biologyExperts/libs/components/Experts'
import { TPageProps } from '~/shared/types/commonTypes'

const BiologyExperts = ({ nextPagePath, pageId }: TPageProps) => (
  <Experts nextPagePath={nextPagePath} pageId={pageId} />
)

export default BiologyExperts
